import { useState, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export const useMenuState = () => {
  const [activeMenu, setActiveMenu] = useState('Dashboard');
  const [sidebarHidden, setSidebarHidden] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({ 'User Management': true, 'Operations': true });
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (location.state?.activeMenu) {
      setActiveMenu(location.state.activeMenu);
    }
  }, [location.state]);

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      const mobile = width < 768;
      const tablet = width >= 768 && width < 1200;
      
      setIsMobile(mobile);
      setIsTablet(tablet);

      if (mobile) {
        setSidebarHidden(true);
        setSidebarCollapsed(false);
      } else if (tablet) {
        setSidebarHidden(true);
        setSidebarCollapsed(true);
      } else {
        setSidebarHidden(false);
        setSidebarCollapsed(false);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    if (isMobile || isTablet) {
      setSidebarHidden(!sidebarHidden);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const toggleSubMenu = (menuName) => {
    setExpandedMenus(prev => ({ ...prev, [menuName]: !prev[menuName] }));
  };

  const handleMenuClick = (menuName) => {
    setActiveMenu(menuName);
    
    // Reset pagination to page 0 when switching tabs
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', '0');
    setSearchParams(newParams);

    if (isMobile || isTablet) {
      setSidebarHidden(true);
    }
  };

  const getMainMargin = () => {
    if (isMobile || isTablet) return '0';
    return sidebarCollapsed ? '80px' : '280px';
  };

  return {
    activeMenu,
    setActiveMenu,
    sidebarHidden,
    setSidebarHidden,
    sidebarCollapsed,
    isMobile,
    isTablet,
    expandedMenus,
    toggleSidebar,
    toggleSubMenu,
    handleMenuClick,
    getMainMargin
  };
};
